import { NodeonContextProvider } from "@nodeon/react-components";
import React from "react";
import { ApiResponse } from "~/api/GeneratedApi";
import { useApiErrorHandler } from "~/utils/hooks/useApiErrorHandler";

interface Props {
  children: React.ReactNode;
}

export const NodeonContextWrapper = ({ children }: Props): JSX.Element => {
  const apiErrorHandler = useApiErrorHandler();
  return (
    <NodeonContextProvider
      options={{
        smartform: {
          onFailMiddleware: (e) => apiErrorHandler(e as Error | ApiResponse),
        },
        popup: {
          usePopups: true,
        },
      }}
    >
      {children}
    </NodeonContextProvider>
  );
};
